<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataListt" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="Box">
      <div class="table_tab">
        <div class="inquiry">
          <div class="headerbox">
            <div class="header">
              数据筛选
            </div>

          </div>
          <el-form :inline="true" ref="queryForm" :model="search" size="small" class="search-form">
            <el-form-item label="客户信息">
              <el-input v-model="form.customerInfo" placeholder="请输入客户信息"></el-input>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="form.orderNo" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="订单日期">
              <el-date-picker v-model="allotDate" type="daterange" unlink-panels clearable range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" @change="onChangeTime"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="积分类型">
              <el-select v-model="form.typeFlag" placeholder="请选择积分类型" filterable clearable>
                <el-option v-for="item in dictionaries.points_type" :key="item.dictId" :label="item.dictName"
                  :value="item.dictId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="积分状态">
              <el-select v-model="form.status" placeholder="请选择积分状态" filterable clearable>
                <el-option v-for="item in dictionaries.points_records_status" :key="item.dictId" :label="item.dictName"
                  :value="item.dictId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="到账日期">
              <el-date-picker v-model="allotDate1" type="daterange" unlink-panels clearable range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" @change="onChangeTime"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchEvent()" plain type="primary">搜索</el-button>
              <el-button plain @click="fetchData('reset')" type="primary">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="inquiryTab">
          <div class="inquiryTab_header">
            <div class="tabTitle">积分流水</div>
            <div><el-button type="primary" @click="exportData()" size="small" icon="el-icon-upload">导出积分明细</el-button>
            </div>
          </div>
          <div class="table">
            <matrix-table :dataList="manage.page.list" :config="manage.config" :loading="manage.loading"></matrix-table>
            <div class="page">
              <div class="block">
                <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange"
                  :current-page="manage.page.pageNo" :page-size="manage.page.pageSize" :page-sizes="[3, 5, 10, 20, 50]"
                  layout="total,sizes, prev, pager, next" :total="manage.page.totalNum">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import MatrixTable from './components/MatrixTable.vue'
// import common from './mixins/common'
import navbar from '@/components/navbar.vue'
export default {
  // mixins: [common],
  watch: {
    $route: {
      handler: function (newV, oldV) {
        this.fetchData()
      },
      deep: true
    },
  },
  components: {
    MatrixTable,
    navbar,
    breadcrumbTop
  },
  data() {
    return {
      dataListt: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '积分记录详情', path: '', type: '1' }
        ]
      },
      form: {
        monthDate: '', // string 佣金月份
        customerInfo: '', // string or null 客户信息
        orderNo: '', // string or null 订单号
        orderTimeStart: '', // string or null 订单日期-开始
        orderTimeEnd: '', // string or null 订单日期-结束
        platformId: '', // integer or null 来源平台 数据来源：/order/v1-2/platform/dataList
        settleTimeStart: '', // integer or null 更新时间-开始
        settleTimeEnd: '', // string or null 更新时间-结束
        status: '',
        typeFlag: ''
      },
      platformList: [], // 平台列表
      manage: {
        loading: false,
        page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }, // 员工业绩统计(XX年XX月)
        sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
        config: [
          { prop: 'customerName', label: '客户信息', slot: 'customerName' },
          { prop: 'orderNo', label: '订单号', slot: 'orderNo1' },
          { prop: 'orderGoodsStr', label: '订单商品', slot: 'orderGoodsStr1' },
          { prop: 'orderCreatedTime', label: '订单日期', slot: 'orderCreatedTime1' },
          { prop: 'receivableAmount', label: '订单金额', slot: 'receivableAmount1', width: 100 },
          { prop: 'points', label: '积分' },
          { prop: 'typeFlagLabel', label: '积分类型' },
          { prop: 'statusLabel', label: '积分状态' },
          { prop: 'settleTime', label: '到账时间', slot: 'settleTime1' }
        ]
      },
      parArray: [],
      search: {
        platformId: ''
      },
      allotDate: [], // 订单日期
      allotDate1: [], // 到账日期
      dictionaries: {}
    }
  },
  mounted() {

  },
  created() {
    this.form.monthDate = this.$route.query.monthDate
    this.fetchData()
    // this.getPlatformList() // 获取平台列表
    // // 权限设定判断
    // this.limits = JSON.parse(sessionStorage.getItem('limit'))
    // const params = this.limits.buttonTreeDto.filter(
    //   (item) => item.menuCode === 'categoryManage'// 菜单管理里面的菜单编码
    // )
    // params[0].buttonList.forEach((item) => {
    //   this.parArray.push(item.code)
    // })
    // console.log(this.parArray)
    // // 权限设定判断
    // document.onkeydown = (e) => {
    //   const key = window.event.keyCode
    //   if (key == 13) {
    //     this.searchEvent()
    //   }
    // }
    this.getDictionaries('points_type')
    this.getDictionaries('points_records_status')
  },
  beforeRouteLeave(to, form, next) {
    document.onkeydown = null
    next()
  },

  methods: {
    //导出数据
    exportData() {
      if (this.allotDate) {
        this.form.orderTimeStart = this.allotDate[0]
        this.form.orderTimeEnd = this.allotDate[1]
      } else {
        this.form.orderTimeStart = ''
        this.form.orderTimeEnd = ''
      }
      if (this.allotDate1) {
        this.form.settleTimeStart = this.allotDate1[0]
        this.form.settleTimeEnd = this.allotDate1[1]
      } else {
        this.form.settleTimeStart = ''
        this.form.settleTimeEnd = ''
      }

      this.axios.post('/point/goods/exportMonthlyPointsDetail', this.form).then(res => {
        if (res.code == 0) {
          // this.exportLoading = false
          this.$message.success('导出成功')
          this.downloadlink(res.data)
        }
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/getDictGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    onChangeTime(e) { // 订单日期
      if (e) {
        this.form.orderDateStart = e[0]
        this.form.orderDateEnd = e[1]
      } else {
        this.form.orderDateStart = ''
        this.form.orderDateEnd = ''
      }
    },
    searchEvent() {
      this.manage.page.pageNo = 1
      this.fetchData('search')
    },
    // 获取平台列表
    getPlatformList() {
      const params = {}
      this.$api.platformDataList(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    onSizeChange(sizeChange) {
      this.manage.page.pageNo = 1
      this.manage.page.currentPage = 1
      this.manage.page.pageSize = sizeChange
      this.fetchData('search')
    },
    onCurrentChange(currentChange) {
      this.manage.page.pageNo = currentChange
      this.fetchData('search')
    },
    fetchData(type) {
      this.manage.loading = true
      if (type === 'reset') {
        this.manage.page.pageNo = 1
        this.manage.page.pageSize = 10
        this.manage.page.currentPage = 1
        this.form = {}
        this.allotDate = []
        this.allotDate1 = []
      }
      let params = {
        pageNo: this.manage.page.pageNo,
        pageSize: this.manage.page.pageSize,
        monthDate: this.$route.query.monthDate
      }
      if (type === 'search') {
        // this.manage.page.currentPage = 1
        // this.manage.page.pageNo = 1
        // params.pageNo = 1
        if (this.allotDate) {
          this.form.orderTimeStart = this.allotDate[0]
          this.form.orderTimeEnd = this.allotDate[1]
        } else {
          this.form.orderTimeStart = ''
          this.form.orderTimeEnd = ''
        }
        if (this.allotDate1) {
          this.form.settleTimeStart = this.allotDate1[0]
          this.form.settleTimeEnd = this.allotDate1[1]
        } else {
          this.form.settleTimeStart = ''
          this.form.settleTimeEnd = ''
        }

        params = Object.assign({}, params, this.form)
        console.log('params=', params, this.form)
        // 去除字符串 前后 空格
        for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
      }
      this.axios.post('/point/goods/getMonthlyPointsDetailPage', params).then((res) => {
        if (res.code === 0) {
          this.manage.loading = false
          console.log(res)
          this.manage.page.list = res.data.list
          this.manage.page.totalNum = res.data.totalNum
        } else {
          this.manage.loading = false
        }
      }).catch((err) => {
        console.log(err)
        this.manage.loading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
.Box {
  display: flex;
  justify-content: flex-start;
  width: 100%;

  .table_tab {
    width: 100%;
    margin-bottom: 50px;
  }
}

.table {
  border-radius: 5px;
  width: 100%;
}

.header {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}

.inquiry {
  background: #fff;
  padding: 10px 20px 10px 20px;
  border-radius: 5px;

  .el-form {
    margin-top: 10px;
  }
}

.inquiryTab {
  background: #fff;
  padding: 10px 20px 20px 20px;
  border-radius: 5px;

  .el-form {
    margin-top: 10px;
  }

  margin-top: 20px;

  .inquiryTab_header {
    display: flex;
    justify-content: space-between;

    /deep/ .el-button {
      height: 40px;
    }
  }
}

/deep/.el-table__expand-icon>.el-icon {
  color: transparent;
}

.table {
  margin-top: 10px;
  border: 1px solid #e8eaec;
  border-radius: 0;

  /deep/ .el-input--suffix .el-input__inner {
    color: #000;
    width: 104px;
    box-shadow: none;
  }

  /deep/ .el-button {
    padding: 10px 13px;
  }
}

.page {
  text-align: right;
  width: 100%;
  background: #f5f5f5;
  padding-right: 30px;
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 5;

  span {
    font-size: 14px;
    color: #666;
    display: inline-block;
    margin-left: 10px;
  }

  .el-pagination {
    display: inline-block;
    vertical-align: middle;
  }
}

/deep/.el-table__row:hover {
  color: rgb(45, 125, 223);
}

/deep/.el-dialog__header {
  padding: 20px 20px 20px 20px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 25px;
  color: #333333;
}

/deep/.el-dialog {
  border-radius: 10px;
}

/deep/.el-dialog__headerbtn {
  top: 15px;
}

.headerbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  border-bottom: 1px solid #ededed;
  padding-bottom: 10px;
}

.tabTitle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #333333;
  opacity: 1;
  margin-top: 10px;
  margin-bottom: 20px;
}

/deep/.el-form-item__label {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

/deep/ .el-dialog__footer {
  margin-top: -20px;
  padding-top: 20px;
}

/deep/.el-table thead {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #333333;
  opacity: 1;
}

.btnClass {
  margin-top: 20px;
  display: flex;
  justify-content: right;
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    width: 100%;
    max-width: 303px;
    min-width: 299px;

    /deep/.el-form-item__label {
      width: 70px;
    }

    /deep/.el-form-item__content {
      width: calc(100% - 70px);

      .el-select,
      .el-date-editor,
      .el-cascader {
        width: 100%;
      }
    }
  }
}
</style>
